import { Format, Routing, Search, SortKeys } from "@common/_constants";
import { Button } from "@common/components/Atoms/Button";
import LocalTime from "@common/components/Atoms/LocalTime";
import { TileSize } from "@common/models";
import { ReferralService } from "@pro/_services";
import { DashboardTile } from "@pro/components/Organisms/DashboardTile";
import { ReferCandidate } from "@pro/containers/Modals/Refer";
import moment from "moment";
import React, { Component } from "react";
import { Link } from "react-router-dom";

const DashboardTileReferralsNav = () => (
    <div className="c-dashboard__tile-nav">
        <Link
            to={`${Routing.Client.Pro.Referrals.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
            }=${Search.JobCandidatePhase.REVIEW}`}
            className="c-link no-underline">
            review
        </Link>
        <Link
            to={`${Routing.Client.Pro.Referrals.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
            }=${Search.JobCandidatePhase.CONSIDERATION}`}
            className="c-link no-underline">
            consideration
        </Link>
        <Link
            to={`${Routing.Client.Pro.Referrals.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
            }=${Search.JobCandidatePhase.ELIMINATED}`}
            className="c-link no-underline">
            eliminated
        </Link>
        <Link
            to={`${Routing.Client.Pro.Referrals.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
            }=${Search.JobCandidatePhase.HIRED}`}
            className="c-link no-underline">
            hired
        </Link>
        <Link to={Routing.Client.Pro.Referrals.SEARCH} className="c-link no-underline">
            all
        </Link>
    </div>
);

interface DashboardReferAFriendFooterProps {
    history: any;
}
interface DashboardReferAFriendFooterState {
    referCandidateModalIsOpen: boolean;
}
class DashboardReferAFriendFooter extends Component<
    DashboardReferAFriendFooterProps,
    DashboardReferAFriendFooterState
> {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onReferCandidateOkay = this.onReferCandidateOkay.bind(this);

        this.state = {
            referCandidateModalIsOpen: false,
        };
    }
    openModal() {
        this.setState({ referCandidateModalIsOpen: true });
    }

    closeModal() {
        this.setState({ referCandidateModalIsOpen: false });
    }

    onReferCandidateOkay(id) {
        this.closeModal();
        this.props.history.push("/referrals/" + id);
    }

    render() {
        return (
            <div className="c-dashboard__tile-footer">
                <Button id="refer-friend-button" green={true} small={true} onClick={this.openModal}>
                    refer a candidate
                </Button>

                <ReferCandidate
                    isOpen={this.state.referCandidateModalIsOpen}
                    onOkay={this.onReferCandidateOkay}
                    onCancel={this.closeModal}
                    closeModal={this.closeModal}
                />
            </div>
        );
    }
}

interface ReferralModel {
    job_candidate_id: number;
    user_full_name: string;
    phase_name: string;
    hired_timestamp: string;
    job_name: string;
    total_commission_in_us_dollars: string;
}

interface ReferralsProps {
    history: any;
}
interface ReferralsState {
    referrals: {
        status: string;
        response: ReferralModel[];
    };
}
export class Referrals extends Component<ReferralsProps, ReferralsState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);

        this.state = {
            referrals: {
                status: "pending",
                response: [] as ReferralModel[],
            },
        };
    }

    componentDidMount() {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.search) {
            this._abortControllers.search.abort();
        }
        this._abortControllers.search = new AbortController();
        const signal = this._abortControllers.search.signal;

        ReferralService.search(
            {
                page_size: 10,
                order_by: SortKeys.JobCandidate.CREATE_TIMESTAMP,
                current_page: 1,
                my_applications: false,
            },
            signal
        ).then(resp => {
            this.setState({
                referrals: { status: "success", response: resp.results },
            });
        });
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key => abortControllers[key].abort());
        }
    }

    render() {
        const { referrals } = this.state;
        return (
            <DashboardTile
                title="referrals"
                description="your most current referrals"
                size={TileSize.lg}
                loading={referrals.status === "pending"}
                nav={
                    referrals.status === "success" &&
                    referrals.response.length >= 0 && <DashboardTileReferralsNav />
                }
                footer={<DashboardReferAFriendFooter history={this.props.history} />}>
                <div className="c-dashboard__referrals">
                    {referrals.status === "success" &&
                        referrals.response.map(ref => (
                            <div className="c-dashboard__block" key={ref.job_candidate_id}>
                                <div className="c-dashboard__block-header">
                                    <div className="c-dashboard__block-title">
                                        <Link
                                            className="c-link c-link--magenta"
                                            to={"/referrals/" + ref.job_candidate_id}>
                                            {ref.user_full_name}
                                        </Link>
                                    </div>
                                    <div className="c-dashboard__block-callout">
                                        {ref.phase_name}
                                        <br />
                                        {ref.hired_timestamp && (
                                            <span className="c-dashboard__block-callout--no-lowercase">
                                                {moment.utc().diff(moment(ref.hired_timestamp)) > 0
                                                    ? "started "
                                                    : "starting "}
                                                <LocalTime
                                                    utcTimestamp={ref.hired_timestamp}
                                                    format={Format.Datetime.DATE_ABBR_MONTH}
                                                />
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="c-dashboard__block-body">
                                    <ul>
                                        <li>{ref.job_name}</li>
                                        <li>
                                            {ref.total_commission_in_us_dollars}{" "}
                                            {ref.total_commission_in_us_dollars !== ""
                                                ? "referral reward"
                                                : "referral reward not available"}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        ))}

                    {referrals.status === "success" &&
                        referrals.response.length === 0 && (
                            <div className="c-dashboard__blank">
                                <p className="u-text-gray">
                                    Learn more about what goes into connecting candidates to great
                                    jobs, the hiring process, and earning referral rewards.
                                </p>
                                <div className="u-text-center">
                                    <a
                                        href="https://support.relode.com/collection/49-professionals"
                                        className="c-button"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        get equipped
                                    </a>
                                </div>
                            </div>
                        )}
                </div>
            </DashboardTile>
        );
    }
}
